import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { ROServiceComponent } from './components/ro-service/ro-service.component';
import { ROServiceRequestComponent } from './components/ro-service-request/ro-service-request.component';
import { ClearadvanceComponent } from './components/clearadvance/clearadvance.component';
import { MPFontComponent } from './components/mp-font/mp-font.component';
import { RequestMenuComponent } from './components/request-menu/request-menu.component';
import { PaytovendorComponent } from './components/paytovendor/paytovendor.component';
import { AdminMenuComponent } from './components/admin-menu/admin-menu.component';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { PettycashComponent } from './components/pettycash/pettycash.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AdvancerequestComponent } from './components/advancerequest/advancerequest.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { CompanyComponent } from './components/company/company.component';
import { LoadingComponent } from './components/loading/loading.component';
import { LoginComponent } from './components/login/login.component';
import { DecimalPipe, DatePipe, NgSwitch, SlicePipe } from '@angular/common';
import { PaytoemployeeComponent } from './components/paytoemployee/paytoemployee.component';
import { OtherComponent } from './components/other/other.component';
import { CNTypeComponent } from './components/cntype/cntype.component';
import { BillingToCashComponent } from './components/billingtocash/billingtocash.component';
import { ReceiptVoucherComponent } from './components/receiptvoucher/receiptvoucher.component';
import { JournalVoucherComponent } from './components/journalvoucher/journalvoucher.component';
import { AdminAdjustComponent } from './components/admin-adjust/admin-adjust.component';
import { AdminReceivingdocComponent } from './components/admin-receivingdoc/admin-receivingdoc.component';
import { AdminReverseFIdocComponent } from './components/admin-reversefidoc/admin-reversefidoc.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ApproveComponent } from './components/approve/approve.component';
import { ExporttoSAPComponent } from './components/exportto-sap/exportto-sap.component';
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';
import { ForgetpasswordComponent } from './components/forgetpassword/forgetpassword.component';
import { SetuprecievemailComponent } from './components/setuprecievemail/setuprecievemail.component';
import { AdminTaskComponent } from './components/admin-task/admin-task.component';
import { AdminGlaccountComponent } from './components/admin-glaccount/admin-glaccount.component';
import { HolidayComponent } from './components/holiday/holiday.component';
import { UserPermissionComponent } from './components/user-permission/user-permission.component';
import { SearchComponent } from './components/search/search.component';
import { ReportExportUniversalComponent } from './components/report-export-universal/report-export-universal.component';
import { ReconAccountComponent } from './components/recon-account/recon-account.component';
import { UploadfileService } from './services/uploadfile.service';
import { UploadfileBoxComponent } from './components/uploadfile-box/uploadfile-box.component';
import { ReportMenuComponent } from './components/report-menu/report-menu.component';
import { ReportRejectedComponent } from './components/report-rejected/report-rejected.component';
import { SVMReportComponent } from './components/svmreport/svmreport.component';
import { DailyprojectedcashflowComponent } from './components/dailyprojectedcashflow/dailyprojectedcashflow.component';
import { AdvancetoempreportComponent } from './components/advancetoempreport/advancetoempreport.component';
import { AdminSupportdocComponent } from './components/admin-supportdoc/admin-supportdoc.component';
import { AdminPaymentComponent } from './components/admin-payment/admin-payment.component';
import { ReceiptSupportingDocsReportComponent } from './components/receipt-supporting-docs-report/receipt-supporting-docs-report.component';
import { DetailRequestComponent } from './components/detail-request/detail-request.component';
import { DetailVerifyComponent } from './components/detail-verify/detail-verify.component';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';

import { FieldErrorDisplayComponent } from './components/field-error-display/field-error-display.component';
import { TSFuntionService } from './services/ts-funtion.service';
import { AuthService } from './services/auth.service';
import { SessionExpiredInterceptor } from './services/session-expired.interceptor';
import { SyndataComponent } from './components/syndata/syndata.component';
import { PaymentlistComponent } from './components/paymentlist/paymentlist.component';
import { ManualUpdatefiComponent } from './components/manual-updatefi/manual-updatefi.component';
import { ManualUpdatefiImportComponent } from './components/manual-updatefi-import/manual-updatefi-import.component';
import { AdminPaymentDocImportComponent } from './components/admin-payment-doc-import/admin-payment-doc-import.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ROServiceComponent,
    ROServiceRequestComponent,
    ClearadvanceComponent,
    MPFontComponent,
    RequestMenuComponent,
    PaytovendorComponent,
    PaytoemployeeComponent,
    AdminMenuComponent,
    OnlyNumberDirective,
    PettycashComponent,
    AdvancerequestComponent,
    CompanyComponent,
    LoadingComponent,
    LoginComponent,
    FieldErrorDisplayComponent,
    OtherComponent,
    CNTypeComponent,
    BillingToCashComponent,
    ReceiptVoucherComponent,
    JournalVoucherComponent,
    AdminAdjustComponent,
    AdminReceivingdocComponent,
    AdminReverseFIdocComponent,
    ApproveComponent,
    ExporttoSAPComponent,
    ChangepasswordComponent,
    ForgetpasswordComponent,
    SetuprecievemailComponent,
    AdminTaskComponent,
    AdminGlaccountComponent,
    HolidayComponent,
    SearchComponent,
    ReportExportUniversalComponent,
    UserPermissionComponent,
    ReconAccountComponent,
    UploadfileBoxComponent,
    ReportMenuComponent,
    ReportRejectedComponent,
    SVMReportComponent,
    DailyprojectedcashflowComponent,
    AdvancetoempreportComponent,
    AdminSupportdocComponent,
    AdminPaymentComponent,
    ReceiptSupportingDocsReportComponent,
    DetailRequestComponent,
    DetailVerifyComponent,
    SessionTimeoutComponent,
    SyndataComponent,
    PaymentlistComponent,
    ManualUpdatefiComponent,
    ManualUpdatefiImportComponent,
    AdminPaymentDocImportComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: LoginComponent, pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'changepassword', component: ChangepasswordComponent },
      { path: 'forgetpassword', component: ForgetpasswordComponent },
      { path: 'setuprecievemail', component: SetuprecievemailComponent },
      { path: 'syndata', component: SyndataComponent },
      {
        path: '',
        component: MPFontComponent,
        children: [
          { path: 'home', component: HomeComponent },
          { path: 'ro-service', component: ROServiceComponent },
          { path: 'ro-service-request', component: ROServiceRequestComponent },
          { path: 'search', component: SearchComponent },
          { path: 'report-export-universal', component: ReportExportUniversalComponent },
          { path: 'paytovendor', component: PaytovendorComponent },
          { path: 'paytoemp', component: PaytoemployeeComponent },
          { path: 'advancerequest', component: AdvancerequestComponent },
          { path: 'clearadvance', component: ClearadvanceComponent },
          { path: 'pettycash', component: PettycashComponent },
          { path: 'other', component: OtherComponent },
          { path: 'cntype', component: CNTypeComponent },
          { path: 'billingtocash', component: BillingToCashComponent },
          { path: 'receiptvoucher', component: ReceiptVoucherComponent },
          { path: 'journalvoucher', component: JournalVoucherComponent },

          { path: 'request-menu', component: RequestMenuComponent },
          { path: 'admin-menu', component: AdminMenuComponent },
          { path: 'approve', component: ApproveComponent },

          { path: 'admin-task', component: AdminTaskComponent },
          { path: 'company', component: CompanyComponent },
          { path: 'holiday', component: HolidayComponent },
          { path: 'admin-userpermission', component: UserPermissionComponent },
          { path: 'admin-glaccount', component: AdminGlaccountComponent },
          { path: 'admin-receivingdoc', component: AdminReceivingdocComponent },
          { path: 'admin-reversefidoc', component: AdminReverseFIdocComponent },
          { path: 'admin-adjust', component: AdminAdjustComponent },
          { path: 'admin-reconaccount', component: ReconAccountComponent },
          { path: 'exportto-sap', component: ExporttoSAPComponent },
          { path: 'admin-payment', component: AdminPaymentComponent },
          { path: 'admin-payment-doc-import', component: AdminPaymentDocImportComponent },
          { path: 'admin-supportdoc', component: AdminSupportdocComponent },
          { path: 'manual-updatefi', component: ManualUpdatefiComponent},
          { path: 'manual-updatefi-import', component: ManualUpdatefiImportComponent },


          { path: 'report-menu', component: ReportMenuComponent },
          { path: 'report-advance', component: AdvancetoempreportComponent },
          { path: 'report-payment-list', component: PaymentlistComponent },
          { path: 'report-svm', component: SVMReportComponent },
          { path: 'report-rejected', component: ReportRejectedComponent },
          { path: 'Receipt_Supporting_Docs_Report', component: ReceiptSupportingDocsReportComponent },
          { path: 'report-daily', component: DailyprojectedcashflowComponent },

          { path: 'detail-request', component: DetailRequestComponent },
          { path: 'detail-verify', component: DetailVerifyComponent },

          { path: 'SessionTimeout', component: SessionTimeoutComponent }
        ]
      }
    ]),
    BrowserAnimationsModule,
    //DatePicker
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    //Page
    PaginationModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    ModalModule.forRoot(),
    //Core Function
  ],
  providers: [
    TSFuntionService,
    DecimalPipe,
    DatePipe,
    SlicePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionExpiredInterceptor,
      multi: true
    }
  ],/*, AuthService*/
  bootstrap: [AppComponent]
})
export class AppModule { }
